import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { AgentFilter } from "@/modules/shift-plan-overview/components/agent-filter"
import { LanguageFilter } from "@/modules/shift-plan-overview/components/language-filter"
import { LicenseFilter } from "@/modules/shift-plan-overview/components/license-filter"
import { QualificationFilter } from "@/modules/shift-plan-overview/components/qualification-filter"
import { ShiftFilter } from "@/modules/shift-plan-overview/components/shift-filter"
import { ShiftPlanDatePicker } from "@/modules/shift-plan-overview/components/shift-plan-date-picker"
import { SpecialtyFilter } from "@/modules/shift-plan-overview/components/specialty-filter"
import { TeamFilter } from "@/modules/shift-plan-overview/components/team-filter"
import {
  hasActiveFilters,
  useShiftPlanFiltersStore,
} from "@/modules/shift-plan-overview/stores/useShiftPlanFiltersStore"
import type { ShiftPlanRoleFilter } from "@/types/__generated__/union-types"

interface ShiftPlanFiltersProps {
  activeTab: ShiftPlanRoleFilter | string
}

const ClearFiltersButton = () => {
  const { t } = useTranslation()
  const resetFilters = useShiftPlanFiltersStore((state) => state.actions.resetFilters)
  const filters = useShiftPlanFiltersStore((state) => state.filters)
  const selectedDate = useShiftPlanFiltersStore((state) => state.selectedDate)
  const isLoading = useShiftPlanFiltersStore((state) => state.isLoading)

  const isDateChanged = selectedDate.toDateString() !== new Date().toDateString()
  const hasFilters = isDateChanged || hasActiveFilters(filters)

  return (
    <Button
      variant="secondary"
      data-testid="shift-plan-clear-filters"
      className={cn(
        "text-primary border-none bg-transparent px-2 py-0",
        (!hasFilters || isLoading) && "text-on-surface-disabled pointer-events-none",
      )}
      onClick={() => resetFilters()}>
      {t("common.button.clearFilters")}
    </Button>
  )
}
export const ShiftPlanFilters = ({ activeTab }: ShiftPlanFiltersProps) => {
  const isCcaTab = activeTab === "CALL_CENTER_AGENTS"

  return (
    <div className="flex w-full flex-wrap items-center gap-2" data-testid="shift-plan-filters">
      <ShiftPlanDatePicker />
      <AgentFilter activeTab={activeTab} />
      <ShiftFilter />
      <LanguageFilter />
      {!isCcaTab && <SpecialtyFilter />}
      {!isCcaTab && <TeamFilter />}
      {!isCcaTab && <LicenseFilter />}
      <QualificationFilter />
      <ClearFiltersButton />
    </div>
  )
}
